<template>

    <v-dialog :value="modal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <div class="align-v-center cover-bg">
          <v-container grid-list-md text-xs-center>
            <v-layout align-center justify-center row>
              <v-flex sm12 md8>
                <v-card class="elevation-12 pb-4">
                   <offset-heading 
                   titleClass="mb-2 headline font-weight-bold"
                   title="ENTER YOUR ACCESS CODE" 
                   subtitle="Two-factor authentication is enabled for this account. We've sent an SMS to your phone with the access code.">
                     <v-btn
                      slot="action"
                      @click="Logout()"
                      fab 
                      color="white"
                      :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
                    >
                      <v-icon dark class="primary--text">fas fa-long-arrow-alt-left</v-icon>
                    </v-btn>
                   </offset-heading>

                   <div class="px-4 mx-1 mt-7 pt-7">
                    <v-layout row wrap>
                      <v-flex sm12 md12 lg12>
                        <v-card-text class="px-5">
                          <v-form ref="authenticate-form" @submit.prevent="authenticate" onSubmit="return false;">
                            <v-text-field
                              v-model="form.code"
                              :rules="authCodeRules"
                              prepend-icon="fas fa-sign-in-alt"
                              required
                              validate-on-blur
              
                              name="Paste Authentication Code"
                              label="Paste Authentication Code"
                              type="number">
                            </v-text-field>
                            <div class="px-5">
                              <v-btn
                                color="primary"
                                fab
                                medium
                                @click="authenticate($event)"
                              >
                                <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                              </v-btn>
                            </div>
                          </v-form>
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                   </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-card>
    </v-dialog>

</template>
<script>
import NormalApi from '@/components/Controllers/NormalApi';
import AuthApi from '@/components/Controllers/AuthApis';
import Env from '@/env';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      form: {
        code: '',
      },
      authCodeRules: [
        v => !!v || 'Code is required',
      ],
    };
  },
  computed: {
    modal() {
      if (this.$store.getters.getLoggedInStep === '2_factor_authenticate') {
        return true;
      }
      return false;
    },
  },
  methods: {

     /**
     * Authenticate user 
     */
    authenticate() {
      if (this.$refs['authenticate-form'].validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/users/login/code`;
        NormalApi.postApi(url,{
          'api-token': Env.apiToken 
        }, { code: parseInt(this.form.code) })
          .then((response) => {
            this.spinner(false);
            this.$store.dispatch('SET_USER_TOKEN', response.data.payload.token);
            this.$store.dispatch('SET_USER_DETAILS', response.data.payload.user);
            // this.snackbar({
            //   text: response.data.msg,
            //   timeout: 3000,
            //   open: true,
            // });
            return response.data.payload.user;
          })
          .then((res) => {
             this.fetchUserBusinessList();
          })
          .catch((err) => {
            this.spinner(false);
            this.snackbar({
              text: err.response.data.msg ? err.response.data.msg :'Please try again later.',
              timeout: 3000,
              open: true,
            });
          });
      }
    },

     /**
     * Fetch account list, if multiple show User account list else set the default
     */
    fetchUserBusinessList() {
      /**
       * Get user account list
       */
      const url = `${Env.url}/api/v1/users/businesses`;
      AuthApi.getApi(url, {})
      .then((res) => {
        // Store user account in store
        this.$store.dispatch('SET_USER_ACCOUNTS', res.data.payload);
        // this.snackbar({
        //   text: res.data.msg ? res.data.msg : 'Successfully fetched businesses.',
        //   timeout: 3000,
        //   open: true,
        // });
        return res.data.payload;
      })
      .then((businesses) => {
        /**
        * If account is more than 1 set popup to choose which account to login
        * Else if only one account account found autoselect that account
        */
        // this.snackbar({
        //   text: 'Creating account session.',
        //   timeout: 3000,
        //   open: true,
        // });

        // If only 1 business, activate it 
        if (businesses.length === 1) {
          AuthApi.setActiveBusiness(businesses[0].id).then((res) => {
             if(res) {
               this.spinner(false);
               this.snackbar({
                  text: 'Successfully logged in.',
                  timeout: 4000,
                  open: true,
              });
              
              this.$router.push({ name: 'Applications' }); 

             } else {
               this.spinner(false);
               this.snackbar({
                  text: 'Please try again later',
                  timeout: 4000,
                  open: true,
                });
             }
          });
        } else {
          // There are multiple account show account list popup
          this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_chooseAccount');
        }
      })
      .catch(() => {
        this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_chooseAccount');
      });
    },

    /**
     * Logout 
     */
    Logout() {
      this.$store.dispatch('SET_USER_LOGIN_STEP', '');
      this.$store.dispatch('SET_USER_DATA_EMPTY', '');
      this.$router.push({ name: 'Login' });
      this.spinner(false);
    },

    ...mapActions({
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>

